import React from 'react';
import { SummaryDownArrow, SummaryUpArrow } from '../styles';

export function getIcon(percentage) {
  if (percentage < 0) return <SummaryDownArrow />;
  if (percentage > 0) return <SummaryUpArrow />;
  return null;
}
